import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngxs/store';
import { IS_BROWSER } from '@libs/is-browser';
import { FetchCloudSpace } from '@apps/clos-sessions/state/cloud';

@Injectable({
  providedIn: 'root',
})
export class CloudStateInitGuard implements CanActivate {
  protected isBrowser = inject(IS_BROWSER);

  protected store = inject(Store);

  canActivate(): true {
    if (this.isBrowser) {
      this.store.dispatch(new FetchCloudSpace());
    }

    return true;
  }
}
